import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Microsoft Entra ID (Azure AD) authentication.
 * Uses OAuth 2.0 Authorization Code flow with PKCE (default in MSAL.js v2+).
 *
 * Environment variables (via Vite's import.meta.env):
 * - VITE_AZURE_AD_CLIENT_ID: Entra App Registration client ID
 * - VITE_AZURE_AD_TENANT_ID: Azure AD tenant ID
 * - VITE_REDIRECT_URI: OAuth redirect URI
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3000',
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3000',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes requested during login.
 * - openid, profile, email: standard OIDC scopes
 * - User.Read: access user profile via Microsoft Graph
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

/**
 * Scopes for Microsoft Graph API calls (SharePoint file access).
 */
export const graphScopes = {
  scopes: ['Files.Read.All', 'Sites.Read.All'],
};
